/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ToggleProcedureVisibilityDto
 */
export interface ToggleProcedureVisibilityDto {
    /**
     * Set to true to hide the procedure from the patient, false to make it visible again.
     * @type {boolean}
     * @memberof ToggleProcedureVisibilityDto
     */
    isHiddenFromPatient: boolean;
}

/**
 * Check if a given object implements the ToggleProcedureVisibilityDto interface.
 */
export function instanceOfToggleProcedureVisibilityDto(value: object): value is ToggleProcedureVisibilityDto {
    if (!('isHiddenFromPatient' in value) || value['isHiddenFromPatient'] === undefined) return false;
    return true;
}

export function ToggleProcedureVisibilityDtoFromJSON(json: any): ToggleProcedureVisibilityDto {
    return ToggleProcedureVisibilityDtoFromJSONTyped(json, false);
}

export function ToggleProcedureVisibilityDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ToggleProcedureVisibilityDto {
    if (json == null) {
        return json;
    }
    return {
        
        'isHiddenFromPatient': json['isHiddenFromPatient'],
    };
}

export function ToggleProcedureVisibilityDtoToJSON(json: any): ToggleProcedureVisibilityDto {
    return ToggleProcedureVisibilityDtoToJSONTyped(json, false);
}

export function ToggleProcedureVisibilityDtoToJSONTyped(value?: ToggleProcedureVisibilityDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isHiddenFromPatient': value['isHiddenFromPatient'],
    };
}

